import { FC } from 'react';
import { Text, TextProps } from '@qga/roo-ui/components';

type Props = Pick<TextProps, 'fontSize'>;

const MainText: FC<Props> = ({ children, fontSize = ['base', 'lg'] }) => (
  <Text as="div" fontSize={fontSize} lineHeight="normal" mb={0}>
    {children}
  </Text>
);

export default MainText;
